export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5637.dea1c438.jpg";